(function($, api){

  const paramsKeyStoreKey = 'dfSmsQueryParams';

  /**
   * Responsible for creating a URL param string;
   * @param keyStore
   *
   * @return {string} the URL param string
   */
  function createReadableParams(keyStore){
    let str = '';
    for(let key in keyStore){
      if(keyStore.hasOwnProperty(key)){
        if(str.length){
          str += '\n';
        }
        str += `${key}: ${keyStore[key]}`
      }
    }
    return str;
  }

  /**
   * Responsible for formatting a phone number to a US number.
   * @param entry
   * @returns {string}
   */
  function formatUSNumber(entry = '') {
    const match = entry
      .replace(/\D+/g, '').replace(/^1/, '')
      .match(/([^\d]*\d[^\d]*){1,10}$/)[0]
    if(match.length !== 10){
      return match;
    }
    const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
    const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
    const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''
    return `${part1}${part2}${part3}`
  }

  $(document).ready(() => {
    let smsLinks = document.querySelectorAll('a[href^="sms:"]');
    let isSaved = false;
    let urlParams = null;
    const isMobile = window.mobileDetect.mobile();
    const keyValues = api.getURLQueryParams();
    const savedKeyValues = JSON.parse(window.localStorage.getItem(paramsKeyStoreKey));

    smsLinks.forEach((anchor) => {
      const mapping = [
        {
          body: 'SPIKE',
        }, {
          body: 'JOIN'
        }
      ];
      let mappingValue = '';

      let textPos = -1;
      for(const obj of mapping){
        const bodyPos = anchor.href.indexOf(`body=${obj.body}`);
        if (bodyPos > -1) {
          textPos = bodyPos;
          mappingValue = obj.body;
          break;
        }
      }

      if (textPos > -1) {
        // Only save key value stores once since we are looping
        if (!isSaved) {
          // Immediately save the values to local storage when mapping links are used
          if (!savedKeyValues) {
            // Save the params for the first time
            window.localStorage.setItem(paramsKeyStoreKey, JSON.stringify(keyValues));
            urlParams = createReadableParams(keyValues);
          } else {
            // Update or add params
            for (let key in keyValues) {
              if (keyValues.hasOwnProperty(key)) {
                // Save a new key/value or update an existing key/value
                savedKeyValues[key] = keyValues[key];
              }
            }
            window.localStorage.setItem(paramsKeyStoreKey, JSON.stringify(savedKeyValues));
            urlParams = createReadableParams(savedKeyValues);
          }
          isSaved = true;
        }

        // Update the anchor links
        if(urlParams.length){
          anchor.href = anchor.href + encodeURI('\n' + urlParams);
        }

        // Determine how much of the string to strip off.
        let startAt = 4;
        const hasPlus = anchor.href.indexOf('sms:+');
        if (hasPlus > -1) {
          startAt = 5;
          if (anchor.href.substr(startAt, 1) === "1") {
            startAt = 6;
          }
        }
        // Get the phone number
        const phoneNumber = formatUSNumber(anchor.href.substr(startAt, 10));
        
        if (!isMobile) {
          const linkContent = anchor.querySelector('div:first-child');
          // Link with text inside of a div (standard buttons)
          if (!$(anchor).hasClass('modal_title_link')) {
            if (linkContent) {
              linkContent.textContent = `Text ${mappingValue} to ${phoneNumber}`;
            } else {
              anchor.textContent = `Text ${mappingValue} to ${phoneNumber}`;
            }
          }
          anchor.removeAttribute('target');
          anchor.href = "javascript:void(0)";
        }
      }
    });
  });
})(jQuery, window.dfApi);
